import toast from 'react-hot-toast';

import theme from "../assets/styles/index.scss";

export const showErrorToast = (message = "Something went wrong !!") =>
  toast.error(message, {
    position: "top-center",
    duration: 10000,
    style: {
      border: `1px solid ${theme.theme_red}`,
      backgroundColor: theme.theme_light_red,
      color: theme.theme_red,
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500",
    },
    iconTheme: {
      primary: theme.theme_red
    }
  });

export const showSuccessToast = (message = "Successful !!") =>
  toast.success(message, {
    position: "top-center",
    duration: 4000,
    style: {
      border: `1px solid ${theme.theme_green}`,
      backgroundColor: theme.theme_light_green,
      color: theme.theme_green,
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500",
    },
    iconTheme: {
      primary: theme.theme_green
    }
  });
